import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Langs } from "../domain/enums/common/LangsEnum";
import languageServiceFactory from "../services/LanguageServiceImpl";
import LanguageIcon from "../icons/language.svg";
import arrowDownIcon from "../icons/arrDown.svg";
import arrowUpIcon from "../icons/arrUp.svg";
import { DropDirection } from "../types/constants";

const langService = languageServiceFactory();

type LanguageSwitcherProps = {
    dropDirection?: DropDirection;
    dropdownRightOffset?: string;
};

export default function LanguageSwitcher({
    dropDirection = DropDirection.DOWN,
    dropdownRightOffset = "-right-[50px]",
}: LanguageSwitcherProps) {
    const { i18n, t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const currentLang = i18n.language as Langs;

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleChangeLanguage = (lang: Langs) => {
        i18n.changeLanguage(lang);
        langService.setCurrentLang(lang);
        langService.notifyListeners(lang);
        setIsOpen(false);
    };

    const languages = [Langs.UA, Langs.EN];
    const arrowIconsMap = {
        [DropDirection.DOWN]: [arrowDownIcon, arrowUpIcon],
        [DropDirection.UP]: [arrowUpIcon, arrowDownIcon],
    } as const;

    const arrowIcon = arrowIconsMap[dropDirection][isOpen ? 1 : 0];

    return (
        <div className="relative flex items-center">
            <button type="button" aria-label="Зміна мови" onClick={toggleDropdown} className="flex items-center">
                <img src={LanguageIcon} alt="Language" className="w-5 h-5 object-contain" />
                <span className="ml-[6px] w-[26px] h-[23px] text-text-300 text-lg font-medium flex items-center justify-center">
                    {currentLang.toUpperCase()}
                </span>
                <img src={arrowIcon} alt="Toggle language list" className="ml-[12px] w-4 h-4 object-contain" />
            </button>

            {isOpen && (
                <div
                    className={`absolute w-[130px] flex flex-col gap-[12px] p-[15px] bg-white
          border border-border-400 rounded-[7px] shadow-[0px_4px_4px_0px_#36335214] z-50
          ${dropdownRightOffset}
          ${dropDirection === DropDirection.DOWN ? "top-full mt-[12px]" : "bottom-full mb-[12px]"}`}
                >
                    {languages.map((lang) => (
                        <span
                            key={lang}
                            onClick={() => handleChangeLanguage(lang)}
                            className="w-[100px] h-[23px] text-lg font-medium text-text-300 hover:text-primary-400 flex items-center justify-center cursor-pointer"
                        >
                            {t(`languages.${lang}`)}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
}
